"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var _constant2 = require("../Text/constant");
var _default = {
  PropTypes: {
    customProperties: _propTypes.object,
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    message: (0, _propTypes.shape)({
      text: _propTypes.string,
      cta: _propTypes.string
    }),
    textType: (0, _propTypes.oneOf)(_constant2.ARR_TEXT_TYPE),
    textColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS),
    showLeftImage: _propTypes.bool,
    fullWidth: _propTypes.bool,
    border: _propTypes.bool,
    borderRadius: (0, _propTypes.oneOf)(_constant.ARR_BORDER_RADIUS),
    imageUrl: _propTypes.string,
    hasBoxShadow: _propTypes.bool,
    type: _propTypes.string
  },
  DefaultProps: {
    accessible: true,
    theme: _constant.DEFAULT_THEME,
    textType: 'textSmall',
    textColor: 'neutral',
    showLeftImage: true,
    fullWidth: false,
    border: true,
    borderRadius: _constant.ARR_BORDER_RADIUS.normal,
    hasBoxShadow: false
  }
};
exports.default = _default;